import { useEffect, useState } from 'react';
import { loadCSS } from 'fg-loadcss';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme, alpha, styled } from '@mui/material/styles';

import { Grid, Container, Typography, Card, CardMedia, Link, Alert, Dialog, DialogTitle, DialogContent, Box, DialogContentText, DialogActions } from '@mui/material';
// components
import Icon from '@mui/material/Icon';
import { Link as RouterLink, useNavigate, redirect } from 'react-router-dom';


// ----------------------------------------------------------------------

const API_URL = `${process.env.REACT_APP_API_URL}`;

const StyledIcon = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(10),
    height: theme.spacing(10),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
}));


export default function DashboardAppPage() {
    const theme = useTheme();

    const [showAppData, setAppData] = useState([]);
    const [showFailed, setFailedData] = useState(false);

    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    
    useEffect(() => {
        const node = loadCSS(
            'https://use.fontawesome.com/releases/v5.14.0/css/all.css',
            document.querySelector('#font-awesome-css') || document.head.firstChild,
        );
        return () => {
            node.parentNode.removeChild(node);
        };
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const bearer = "Bearer ";

        fetch(`${API_URL}/authen`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": bearer + token }
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'ok') {
                    console.log();
                } else {
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate("/login");
                }
            })
            .catch(() => {
                localStorage.clear();
                sessionStorage.clear()
                navigate("/login");
            });
    });

    useEffect(() => {
        const token = localStorage.getItem('token');
        const bearer = "Bearer ";
        fetch(`${API_URL}/app_connect`, {
            method: 'get',
            headers: { "Content-Type": "application/json", "Authorization": bearer + token }
        }).then(response => response.json())
            .then(data => {
                if (data.length === 0) {
                    setFailedData("กรุณาติดต่อผู้ดูแลระบบเพื่อขอเปิดสิทธิ์การเข้าใช้งานเว็บไซต์ !!")
                } else {
                    setAppData(data)
                }
            }

            )
    }, [])

    console.log('token:', token);
    return (
        <>
            <Helmet>
                <title> Dashboard </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 5 }}>
                    Hi, Welcome back
                </Typography>
                {showFailed && <Alert severity="error"><strong>{showFailed}</strong></Alert>

                }

                <Grid container spacing={3}>
                    {showAppData.map((row, i) => (
                        <Grid item xs={12} sm={3} md={2} key={i} >
                            <Link href={`${row.app_url}?token=${token}`} underline="none" target="_blank">
                                <Card
                                    sx={{
                                        py: 5,
                                        boxShadow: 2,
                                        textAlign: 'center',
                                        color: '#000000',
                                        bgcolor: (theme) => theme.palette.info.lighter,
                                    }}
                                >
                                    <StyledIcon
                                        sx={{
                                            color: (theme) => theme.palette.info.dark,
                                            backgroundImage: (theme) =>
                                                `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
                                                    theme.palette.info.dark,
                                                    0.24
                                                )} 100%)`,
                                        }}>
                                        <Icon baseClassName="fas" className={row.app_icon} sx={{ fontSize: 40, width: 50, height: 40 }} width="0" />
                                    </StyledIcon>
                                    <Typography variant="h6">{row.app_name}</Typography>
                                </Card>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
}


function PopupLine() {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>

            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>สแกน QR Code เพื่อเปิดสิทธิ์การใช้งาน Line-OTP</DialogTitle>
                <DialogContent>
                    <Typography>วิธีเพิ่ม Line-OTP</Typography>
                    <Typography>1. Scan QR-CODE ด้านล่างนี้</Typography>
                    <Box
                        component="img"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAFoCAMAAABNO5HnAAAABlBMVEX///8AAABVwtN+AAAGUklEQVR4Xu3cvW4dRxAFYdnw+7+ynagVFNHoXeqqAqO+bHZ+dnkwwQFB8MePJEmSJEmSJEmSJEmSJEmSJPl/+IsP6Fyw+JcPYM6ddRxf+F3cx3na3nvt2/D99Dcf5M8oaElBSwpaUtCSgpYUtOQfPthcPXGwh7KnEue3MW3nEc95u++yfR91oyUFLSloSUFLClpS0JKCljzu0WPrjd/tndu+rfdyP13zYzuftvOufdSNlhS0pKAlBS0paElBSwpa8rpHf8rVQ7ffI2/P2Xe359xn6UZLClpS0JKClhS0pKAlBS3RejT77FPsw1ufHuzHHBPP/VO60ZKClhS0pKAlBS0paElBS1736E/1zau/sh/Ttp/7tr79FM//rm60pKAlBS0paElBSwpaUtCSxz36uz10sM9u47HNX+OxzW9j2p5/VzdaUtCSgpYUtKSgJQUtKWjJ2aPZT9+6+upb/B6Oie/fxoPjT+lGSwpaUtCSgpYUtKSgJQUtOXs0bf3z6snbej7nmK73fBe/5+l7ru8d3WhJQUsKWlLQkoKWFLSkoCVnXbz6JZ9fvZLrnp7HdYPzfP/2/PL0feM6vxstKWhJQUsKWlLQkoKWFLSEdfCLc8FPW78c1/zgum28udbx/Vx3zX9XN1pS0JKClhS0pKAlBS0paAlr44r99OmYnvZS7ue5HA+ef80PrttwP79n042WFLSkoCUFLSloSUFLClpy1kcuYH/lmJ7Ov3Wdx3m+h98/+JznbHgOdaMlBS0paElBSwpaUtCSgpacNfFc8NPVI7d+uo0H37/N8/ngPMeba901T91oSUFLClpS0JKClhS0pKAlr/9fx9ZH2Xc3T9cNnn/t5/zWc/n9g/vHtv6pbrSkoCUFLSloSUFLClpS0JKtNn5xLWS/5Hr2Ya6na93T85+uG9vzzdP13WhJQUsKWlLQkoKWFLSkoCWsmV9wwdYXt3Vbz9yeb67zN9v51/s5z/HYnlM3WlLQkoKWFLSkoCUFLSloyVVDvyxgX/zd+cF1g+u33sr9W//lOrrW8b1PdaMlBS0paElBSwpaUtCSgpacfx/N3sheyt559U/O8/xxrefzsZ1H2zkcb+sG89h0oyUFLSloSUFLClpS0JKClmz18BcuuPrihufQ03O3c7b97Lncfz0fnB9ct+lGSwpaUtCSgpYUtKSgJQUt2erhL1xw9c6nzwd7KNdxfrAfE8/ZcP+1b/t5eA51oyUFLSloSUFLClpS0JKClrAOfsG+yg1bf+S6wfXbOrrev30n3zfeznP8VjdaUtCSgpYUtKSgJQUtKWjJ47+P3noke+1TPO+7483b7+Q893P8VjdaUtCSgpYUtKSgJQUtKWjJ2aPZX4m9dls3uI799bLt55i2eY657u3Ps+lGSwpaUtCSgpYUtKSgJQUtYY18bOuPPPCaH9c6zo9tHb+P634Xz92+b3SjJQUtKWhJQUsKWlLQkoKWfLpefsGeeY0HP4zrifs3fB/P287Z9m3rqRstKWhJQUsKWlLQkoKWFLTk8d91DPZGzj/FfRyzr7K3vh1fuI+enrPpRksKWlLQkoKWFLSkoCUFLdlq4+lpT+ULPr1+XPv4vVxP3D+2c7b1oxstKWhJQUsKWlLQkoKWFLTk9e+jB3sj13GeY/ZP7ifOcx/HfM73cz3xOfe/1Y2WFLSkoCUFLSloSUFLClpy9uin/fHpus22n32Y/Za2cwbPGxyPrZcPjjfdaElBSwpaUtCSgpYUtKSgJWePvnrrhv2S52y9mPs43mznsP/yOXH9p3SjJQUtKWhJQUsKWlLQkoKWnD16PO2VWz9lf2Vf3fY9fc7v4/y43stzBtdv4003WlLQkoKWFLSkoCUFLSloyeMePdg7x9Yj2Tdpez547tZbr3O4j+s5pmv+0o2WFLSkoCUFLSloSUFLClryukf/aeyr7Mu09eNtvOE8v2NwHcebbrSkoCUFLSloSUFLClpS0JI/3qOf9lH23RlzP/fRNb+53sN5jrmeutGSgpYUtKSgJQUtKWhJQUte9+irL9Lb9VufHhzTNs9zB9/D+e28t7rRkoKWFLSkoCUFLSloSUFLHvfoT/XJ7ZxP99etH29j4nOu5/jSjZYUtKSgJQUtKWhJQUsKOkmSJEmSJEmSJEmSJEmSJEnyyn/fMC5+LizEqgAAAABJRU5ErkJggg=="
                        sx={{ width: 200, height: 200, cursor: 'pointer' }}
                    />

                    <Typography>2. กดรับเพื่อนแล้วเลือกเมนู "ลงทะเบียน"</Typography>
                    <Typography>3. กด Link ที่ได้จาก Line-Bot และกรอกชื่อผู้ใช้และรหัสผ่าน</Typography>
                </DialogContent>
            </Dialog>
        </div>
    )
}